import angular from 'angular';
import constants from 'app/constants';
import {
  praDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './bulk-approve-processes-dialog.controller';
import template from './bulk-approve-processes-dialog.html';


class dialogService {
  getOptions($event, { processes, assessmentId }) {
    return {
      controller,
      controllerAs: 'bulkApproveProcessesDialogVM',
      locals: {
        processes,
        assessmentId
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pra.bulkApproveProcessesDialog', [
  alerts,
  praDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('bulkApproveProcessesDialog', dialogService)
  .name;
